import React from 'react';
import { PropTypes } from 'prop-types';

const SplitButton = ({
  title,
  icon,
  isItemActioning,
  onClick,
  items
}) => (
  <React.Fragment>
    <button className="split-btn" type="button" onClick={ () => onClick(items[0]) }>{ title }</button>
    <div className="split-btn-dropdown">
      <button className="split-btn-sm" type="button">
        <i className={ !isItemActioning ? `icon ${ icon }` : 'icon loading' } />
      </button>
      <div className="dropdown-content">
        {items.map((item, index) => (
          (item && index > 0) && <button type="button" className="split-btn text-ellipsis" onClick={ () => onClick(item) } key={ item.id }>{ item.name }</button>
        ))}
      </div>
    </div>
  </React.Fragment>
);

SplitButton.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  isItemActioning: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape()).isRequired
};

SplitButton.defaultProps = {
  icon: 'icon-download',
  isItemActioning: false
};

export default SplitButton;
